<template>
    <q-dialog ref="dialog" @hide="onDialogHide" persistent>
        <q-card class="q-dialog-plugin " style="width: 30vw; max-width: 90vw;">
            <q-toolbar class="bg-primary text-white">
                <q-toolbar-title v-text="(actionTitle + ' ' + screenTitle).trim()"></q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup></q-btn>
            </q-toolbar>

            <q-form ref="modelForm">
                <q-card-section>
                    <div class="flex column wrap">
                        <div class="row q-col-gutter-lg">
                            <div class="col-12" >
                            <q-input v-model="model.FreshDeskCustomerName" type="text" 
                                     label="FreshDesk customer name" 
                                     autofocus 
                                      
                                      
                                     :rules="[]"
                                     :error="fieldHasError('FreshDeskCustomerName')"
                                     :error-message="fieldErrorMessage('FreshDeskCustomerName')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.HourOfDayToUpdateTickets" type="number" 
                                     label="Hour of the day to update tickets" 
                                      
                                      
                                      
                                     :rules="[]"
                                     :error="fieldHasError('HourOfDayToUpdateTickets')"
                                     :error-message="fieldErrorMessage('HourOfDayToUpdateTickets')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" >
                            <q-checkbox v-model="model.EnableChargeBeeSynchronization" 
                                        label="Update ChargeeBee subscription" 
                                         
                                        
                                        
                                        dense>
                                
                                
                            </q-checkbox>
                        </div>
<div class="col-12" v-show="model.EnableChargeBeeSynchronization === true">
                            <q-input v-model="model.ChargeBeeSubscriptionId" type="text" 
                                     label="ChargeBee subscription id *" 
                                      
                                      
                                      
                                     :rules="[]"
                                     :error="fieldHasError('ChargeBeeSubscriptionId')"
                                     :error-message="fieldErrorMessage('ChargeBeeSubscriptionId')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" v-show="model.EnableChargeBeeSynchronization === true">
                            <q-input v-model="model.ChargeBeeItemPriceId" type="text" 
                                     label="ChargeBee item price id *" 
                                      
                                      
                                      
                                     :rules="[]"
                                     :error="fieldHasError('ChargeBeeItemPriceId')"
                                     :error-message="fieldErrorMessage('ChargeBeeItemPriceId')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>

                        </div>
                    </div>
                </q-card-section>
            </q-form>

            <q-toolbar>
                <div class="q-gutter-xs">
                    
                </div>

                <q-space></q-space>

                <div class="q-gutter-xs" v-if="editMode === true">
                    
                    <q-btn color="primary" :label="actionLabel" @click="onOkClick" :disable="actionLocked"></q-btn>
                    <q-btn color="white" text-color="black" label="Cancel" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
                <div class="q-gutter-xs" v-if="editMode === false">
                    
                    <q-btn color="white" text-color="black" label="Close" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
            </q-toolbar>

            <q-inner-loading :showing="loading">
                <q-spinner-gears size="50px" color="primary"></q-spinner-gears>
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<style>
    
</style>

<script>
    export { default } from './freshdeskticketssettingseditmodel-dialog-screen.js'
</script>